/**
 * The five labeled phases shown in the funnel stepper, mirroring the levelsRx
 * consultation flow. Each phase groups one or more step routes; the stepper
 * highlights a phase as active/completed based on the current step's phase.
 */
export const FUNNEL_PHASE = {
  START: "start",
  PRELIMINARY: "preliminary",
  HEALTH: "health",
  DETAILS: "details",
  ELIGIBILITY: "eligibility",
} as const;

export type FunnelPhase = (typeof FUNNEL_PHASE)[keyof typeof FUNNEL_PHASE];

export const SKIPPED_ANSWER = "__skipped__";

export const INTAKE_QUESTION_KEY = {
  WEIGHT_LOSS_MEDICATION: "weight_loss_medication",
  GLP1_MEDICATION: "glp1_medication",
} as const;
